/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import { ListEnvironmentHistoryFields } from 'modules/environments/interfaces';
import { convertSecondsToMinutes } from 'utils/tsHelpers';

const EMPTY_VALUE = '-';

const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && !Number.isNaN(value);

export const formatOperationalTimingMinutes = (minutes: number): string =>
  `${minutes} ${
    minutes === 1
      ? i18n.t('INSTANCE_MINUTE_KEY')
      : i18n.t('MONITORING_PAGE.MINUTES_KEY')
  }`;

export const formatOperationalTimingBaseline = (
  item: Pick<
    ListEnvironmentHistoryFields,
    'operational_timing_expected' | 'median_seconds' | 'sample_count'
  >
) => ({
  limit: isNumber(item?.operational_timing_expected)
    ? formatOperationalTimingMinutes(item.operational_timing_expected)
    : EMPTY_VALUE,
  median: isNumber(item?.median_seconds)
    ? convertSecondsToMinutes(item.median_seconds)
    : EMPTY_VALUE,
  samples: isNumber(item?.sample_count)
    ? String(item.sample_count)
    : EMPTY_VALUE,
});
